import { render, staticRenderFns } from "./DriverContractWidget.vue?vue&type=template&id=aac47e24&scoped=true&"
import script from "./DriverContractWidget.vue?vue&type=script&lang=js&"
export * from "./DriverContractWidget.vue?vue&type=script&lang=js&"
import style0 from "./DriverContractWidget.vue?vue&type=style&index=0&id=aac47e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac47e24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aac47e24')) {
      api.createRecord('aac47e24', component.options)
    } else {
      api.reload('aac47e24', component.options)
    }
    module.hot.accept("./DriverContractWidget.vue?vue&type=template&id=aac47e24&scoped=true&", function () {
      api.rerender('aac47e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/DriverContractWidget.vue"
export default component.exports